import { DataPage } from "@xbs/muon";
import { getCellIds } from "../helpers/main";
import { IAction, IActionConfig } from "../types";

export class SetValidation implements IAction {
	public config: IActionConfig;
	private _page: DataPage;
	private _prevState: { [key: string]: { type: "select"; options: string[] } | null };

	constructor(config: IActionConfig) {
		this.config = config;
		this._page = config.page;
		this._prevState = {};
	}

	do() {
		const { val, cell, grid } = this.config;
		const { row, col } = getCellIds(cell, grid);
		const meta = this._page.getCell(row, col);
		this._prevState[cell] = meta?.editor || null;
		this._page.setCell(row, col, { editor: val ? { type: "select", options: val } : null });
		this.config.grid.paint();
	}

	undo() {
		const { cell, grid } = this.config;
		const { row, col } = getCellIds(cell, grid);
		this._page.setCell(row, col, { editor: this._prevState[cell] });
		this.config.grid.paint();
	}
}
